<template>
    <div>
        <div class="contact-form">
            <form>
                <div class="form-group">
                    <input type="text" name="name" id="name" class="form-control"
                        placeholder="Name" v-model="contact.name" v-validate="'required'"
                    >
                    <span class="d-block text-danger">{{ errors.first('name') }}</span>
                </div>
                <input type="hidden" name="purpose" :value="purpose">
                <div class="form-group">
                    <input type="email" name="email" id="email" class="form-control"
                        placeholder="Email" v-model="contact.email" v-validate="'required|email'"
                    >
                    <span class="d-block text-danger">{{ errors.first('email') }}</span>
                </div>
                <div class="form-group">
                    <textarea name="message" id="message" cols="30" rows="4" class="form-control"
                        placeholder="Message" v-model="contact.message" v-validate="'required'"
                    ></textarea>
                    <span class="d-block text-danger">{{ errors.first('message') }}</span>
                </div>
                <div class="form-group text-center">
                    <button class="btn btn-primary px-5" @click.prevent="conatctUs($event)">
                        SUBMIT
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    name: 'ContactForm',
    data() {
        return {
            contact: {
                name: '',
                email: '',
                message: ''
            }
        };
    },
    props: ['purpose'],
    methods: {
        conatctUs(e) {
            let btn = e.currentTarget;
            $('.s-v-e').remove();

            this.$validator.validateAll().then(result => {
                if (result) {
                    btn.setAttribute('disabled', '');
                    btn.classList.add('is-loading', 'is-loading-sm');

                    let params = new URLSearchParams();
                    params.append('purpose', this.purpose);
                    params.append('name', this.contact.name);
                    params.append('email', this.contact.email);
                    params.append('message', this.contact.message);

                    axios
                        .post(APIURL + 'contact/send', params)
                        .then(response => {
                            btn.removeAttribute('disabled');
                            btn.classList.remove('is-loading', 'is-loading-sm');

                            let res = response.data;

                            if (res.status == 200) {
                                this.$swal('Success', res.msg, 'success');
                                this.contact = {
                                    name: '',
                                    email: '',
                                    message: ''
                                };
                                this.$validator.reset();
                            } else {
                                if (res.status == 400) {
                                    $.each(res.errors, (k, v) => {
                                        $('#' + k).after(v);
                                    });
                                } else {
                                    this.$swal('Error', res.msg, 'error');
                                }
                            }
                        })
                        .catch(err => {
                            console.log(err);
                        });
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.contact-form {
    .form-control {
        background-color: inherit;
        border: none;
        border-bottom: 1px solid #fff;
        border-radius: 0;
        color: #fff;
    }
    .form-control:focus {
        box-shadow: none !important;
        outline: none !important;
        background-color: none !important;
    }
    textarea {
        resize: none;
    }

    .float-label {
        left: 0;
        top: 7px;
        font-size: 16px;
        pointer-events: none;
    }
    /* active state */
    .form-control:focus ~ .float-label,
    .form-control:valid ~ .float-label {
        top: -18px;
        font-size: 12px;
    }
    /* input colors ---- */
    .form-control:focus ~ label {
        color: #03a9f4;
    }
    .form-control:focus ~ .form-bar:before,
    .form-control:focus ~ .form-bar:after {
        background: #03a9f4;
    }

    .btn-primary {
        background-color: #00416b;
        border-color: #00416b;
        border-radius: 0;
    }
    .btn-primary:hover {
        background-color: #041f31;
        border-color: #041f31;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/ContactForm.vue